<template>
  <div>

    <div class="mk1 w1200">
      <div class="tit">
        <div class="bt">实体投注站帮扶中心</div>
        <div class="nav">
                    <span v-for="(item, index) in mk1.title" :key="index" :class="mk1.active == index ? 'active' : ''"
                          @click="navtit(index)">{{ item }}</span>
        </div>
      </div>
      <!-- <img src="./img/img.png"
           alt=""> -->
      <div class="content">
        <div class="cont">
          <h1>招募最牛的缩水师<br />成就您的彩票梦想</h1>
          <p>
            <span>专业团队</span>
            <span>服务保障</span>
          </p>
          <div class="btns">
            <span @click="bidu.show = true; bidu.title = '投注站必读'">投注站必读</span>
            <span @click="bidu.show = true; bidu.title = '彩票经理必读'">彩票经理必读</span>
            <span @click="bidu.show = true; bidu.title = '彩票代表必读'">彩票代表必读</span>
          </div>
          <div class="more"></div>
        </div>
      </div>
    </div>

    <div class="mk2 w1200">
      <img src="./img/chaoshi.png" alt="" @click="$router.push('/sttzzbfzx/chaoshi')">
      <img src="./img/zhongchou.png" alt="" @click="$router.push('/sttzzbfzx/zhaogu')">
    </div>

    <div style="background-color: #e8e6e7;">
      <div class="mk5 w1200">
        <div class="tit">
          <h3>中国彩票开奖公告</h3>
          <div>Lottery draw</div>
        </div>
        <div class="content">
          <!-- 票种及开奖时间 -->
          <div class="lottery">
            <div v-for="(item, index) in mk5.lottery.arr" :key="index" @click="switchLotteryType(index)">
              <span :class="mk5.lottery.active == index ? 'active' : ''">{{ item.name }}</span>
              {{ item.kj }}
            </div>
          </div>

          <!-- 彩种信息 -->
          <div class="info">
            <img v-show="mk5.lottery.active == 0" src="./img/icon_ssq.png" alt="">
            <img v-show="mk5.lottery.active == 1" src="./img/icon_dlt.png" alt="">
            <img v-show="mk5.lottery.active == 2" src="./img/icon_fc3d.png" alt="">
            <img v-show="mk5.lottery.active == 3" src="./img/icon_pl3.png" alt="">
            <div>
              <div class="one">
                <div>
                  <span class="lt-name">{{ currentResult ? currentResult.typeName : '' }}</span>
                  <span>第 <b>{{ currentResult ? currentResult.cycle : '' }}</b>期开奖结果</span>
                  <span
                      v-if="currentResult && currentResult.remainMoney && currentResult.remainMoney !== '0'">奖池滚存<b>￥{{
                      formatMoney(currentResult.remainMoney) }}元</b></span>
                </div>
                <div v-show="mk5.lottery.active == 0">每周二、四、日 21:15 开奖</div>
                <div v-show="mk5.lottery.active == 1">每周一、三、六 20:30 开奖</div>
                <div v-show="mk5.lottery.active == 2">每日 21:15 开奖</div>
                <div v-show="mk5.lottery.active == 3">每日 20:30 开奖</div>
              </div>
              <div class="num">
                                <span v-for="(item, index) in currentNumbers" :key="index" :class="item.color">{{
                                    item.n }}</span>
              </div>
            </div>
          </div>

          <!-- 开奖结果 -->
          <div class="kjjg">
            <div class="tit">往期开奖结果</div>
            <el-table :data="mk5.history.rows" style="width: 100%">
              <el-table-column label="期号" prop="cycle" width="110" align="center"
                               class-name="cycle-col"></el-table-column>
              <el-table-column label="开奖日期" width="130" align="center">
                <template slot-scope="scope">{{ formatDate(scope.row.openTime) }}</template>
              </el-table-column>
              <el-table-column label="开奖号码" align="center">
                <template slot-scope="scope">
                                    <span v-for="(b, i) in historyNumbers(scope.row)" :key="i" class="hnum"
                                          :class="b.color">{{ b.n }}</span>
                </template>
              </el-table-column>
              <el-table-column label="总销数额(元)" align="center">
                <template slot-scope="scope"><span class="sale-val">{{ formatMoney(scope.row.saleMoney)
                  }}</span></template>
              </el-table-column>
              <el-table-column label="奖池(元)" align="center">
                <template slot-scope="scope"><span class="pool-val">{{ scope.row.remainMoney === '0' ?
                    '-' : formatMoney(scope.row.remainMoney) }}</span></template>
              </el-table-column>
            </el-table>
            <el-pagination v-if="mk5.history.total > 0" class="his-page" layout="prev, pager, next"
                           :total="mk5.history.total" :page-size="mk5.history.pageSize"
                           :current-page="mk5.history.pageNum" @current-change="onHistoryPage">
            </el-pagination>
          </div>

          <!-- 实战超市 -->
          <div class="szcs">
            <div class="left">
              <div class="panel">
                <div class="ico">扶</div>
                <div class="txt">
                  <div class="t">实体投注站帮扶中心</div>
                  <div class="d">专业团队 · 实战方案 · 合同保障</div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="tit">实战超市</div>
              <div class="cs-toolbar cs-nav">
                <div class="cs-group">
                                    <span class="cs-tag" :class="{ active: chaoshi.preType == 0 }"
                                          @click="switchChaoshiLottery(0)">双色球</span>
                  <span class="cs-tag" :class="{ active: chaoshi.preType == 1 }"
                        @click="switchChaoshiLottery(1)">大乐透</span>
                </div>
                <div class="cs-group">
                  <div>期号：{{ issueNumber }}</div>
                  <span class="cs-tag" :class="{ active: chaoshi.type == 0 }"
                        @click="switchChaoshiPeriod(0)">最新期</span>
                  <span class="cs-tag" :class="{ active: chaoshi.type == 1 }"
                        @click="switchChaoshiPeriod(1)">上一期</span>
                  <span class="cs-tag" :class="{ active: chaoshi.type == 2 }"
                        @click="switchChaoshiPeriod(2)">下一期</span>
                </div>
              </div>
              <el-table v-loading="chaoshiLoading" :data="chaoshi_tableData" empty-text="暂无实战方案">
                <el-table-column type="index" label="排名" width="60" align="center"></el-table-column>
                <el-table-column label="实战团队" prop="teamName" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="期数" prop="preNumber" align="center"></el-table-column>
                <el-table-column label="实战方案" align="center" width="200">
                  <template slot-scope="scope">{{ scope.row.title || '-' }}</template>
                </el-table-column>
                <el-table-column label="上期实战盈亏状态" prop="plStatus" align="center"></el-table-column>
                <el-table-column label="缩币价格" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.coin != null && scope.row.coin !== '' ? scope.row.coin + ' 缩币' :
                      '-' }}
                  </template>
                </el-table-column>
                <el-table-column label="认购状态" prop="buyStatus" align="center"></el-table-column>
                <el-table-column label="是否已购买" align="center">
                  <template slot-scope="{ row: item }">
                    <!-- 自己发布的方案 -->
                    <template v-if="item.selfPublished">
                      --
                    </template>
                    <template v-else>
                      <!-- 是否已认购 -->
                      <el-tag v-if="item.purchased" type="success"
                              @click="chaoshiItemDownload(item)">下载</el-tag>
                      <template v-else>
                        <!-- 是否已售空 -->
                        <el-tag v-if="item.actions.isSoldOut" type="info">已售罄</el-tag>
                        <el-tag v-else type="danger" @click="chaoshiItemBuy(item)">购买</el-tag>
                      </template>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination v-if="chaoshi.total > 0" background class="cs-page"
                             layout="prev, pager, next" :total="chaoshi.total" :page-size="chaoshi.pageSize"
                             :current-page="chaoshi.pageNum" @current-change="onChaoshiPage">
              </el-pagination>
            </div>
          </div>

        </div>
        <div class="bg"></div>
      </div>
    </div>

    <!-- 平台推荐缩水团队 -->
    <div class="mk3 w1200">
      <div class="mk3-tit">
        <div class="zh">平台推荐缩水团队</div>
        <div class="en">Preferred shrink</div>
      </div>
      <el-carousel :autoplay="false" arrow="always" height="290px">
        <el-carousel-item v-for="item in mk3.list" :key="item.id">
          <div class="team-card">
            <div class="imgBlock">
              <img class="team-logo" v-if="item.teamAvatar" :src="$img(item.teamAvatar)" alt="">
            </div>
            <div class="team-info">
              <div class="team-name">{{ item.teamName }}</div>
              <div class="team-slogan" v-if="item.teamSlogan">团队口号：{{ item.teamSlogan }}</div>
              <div class="team-desc">{{ item.teamIntro }}</div>
              <div class="team-action">
                <span class="btn" @click="goTeamDetail(item)">查看缩水师</span>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div style="background-color: #787878;">
      <div class="mk4 w1200">
        <div class="ul">
          <ul>
            <li>申请</li>
            <li>彩票代表</li>
            <li>彩票经理</li>
            <li>彩票投注站帮扶</li>
          </ul>
          <ul>
            <li>必读</li>
            <li @click="bidu.show = true; bidu.title = '彩票代表必读'">彩票代表必读</li>
            <li @click="bidu.show = true; bidu.title = '彩票经理必读'">彩票经理必读</li>
            <li @click="bidu.show = true; bidu.title = '投注站必读'">投注站必读</li>
          </ul>
          <ul>
            <li>实战超市</li>
            <li>帮扶投注站</li>
            <li>专业团队出品</li>
          </ul>
          <ul>
            <li>众筹招股</li>
            <li>技术团队入股5%</li>
            <li>平台兜底10%</li>
            <li>按股分红</li>
          </ul>
          <ul>
            <li>合同保障</li>
            <li>实战方案</li>
            <li>实战票</li>
            <li>站长签名</li>
            <li>签订合同</li>
          </ul>
        </div>
        <div class="ewm">
          <div>
            <div class="img">二维码</div>
            <span>实战超市大厅</span>
          </div>
          <div>
            <div class="img">二维码</div>
            <span>众筹招股大厅</span>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="bidu.title" :visible.sync="bidu.show" width="60%">
      <img v-if="bidu.title == '彩票代表必读'" src="./img/bidu/daibiao.png" alt="" style="width:100%;margin:auto">
      <img v-if="bidu.title == '彩票经理必读'" src="./img/bidu/jingli.png" alt="" style="width:100%;margin:auto">
      <div v-if="bidu.title == '投注站必读'" class="tzzbd">
        <p class="tit">
          <span>投注站必读</span>
        </p>
        <p>一、彩票投注站首先书写一份申请书，工作人员核实后，正式报备成为待帮扶的投注站，平台给您按照申请的时间先后排号。</p>
        <p>二、当彩票投注站正式收到平台帮扶通知书或者工作人员的电话通知，就可以办理正式入驻，接收平台的帮扶服务。目前只提供双色球和大乐透的服务。</p>
        <p>三、彩票投注站根据自己是福彩店还是体彩店，在帮扶实战超市大厅预订双色球或大乐透帮扶实战方案。订金是帮扶实战方案的30%，当投注站站长众筹招股在约定的截止时没有成功，订金原路返回到投注站在平台的账户上。四、按照行业惯例，出帮扶方案的团队将认购5%的股权，平台将认购10%的股权，帮扶中心栏目组将认购2%的股权。
        </p>
        <p>四、彩票代表和彩票经理会帮助彩票投注站众筹招股近可能成功，平台收取2%的股权（实战方案本金+实战团队帮扶方案价格）的管理服务费。其中 1%作为彩票代表的劳务酬金，0.2%作为彩票经理的劳务酬金。</p>
        <p>五、彩票投注站众筹招股众筹招股成功，可以第一时间申请缩币提现，也可以先垫付出实战票。</p>
        <p>六、彩票投注站站长出了实战票，请尽快完成缩水网帮扶中心四件套：帮扶合同+帮扶方案+实战票+投注站负责人当期签名拍照上传（我承诺：我将忠实履行缩水网帮扶合同，某某某，年、月、日。)</p>
        <p>七、每期开完奖，彩票投注站请在14小时内完成每一位参与众筹招股股权的兑奖。</p>
      </div>
      <!-- <img src="./img/bidu/touzhuzhan.png"
           alt=""
           style="width:100%;margin:auto"> -->
    </el-dialog>

    <!-- 查看缩水师弹窗 -->
    <el-dialog :title="memberDialog.title" :visible.sync="memberDialog.show" width="50%">
      <el-table v-if="memberDialog.list.length" :data="memberDialog.list" border stripe>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="成员ID" prop="memberUserId" width="100"></el-table-column>
        <el-table-column label="成员姓名" prop="memberName" width="100"></el-table-column>
        <el-table-column label="团队识别码" prop="teamIdent"></el-table-column>
        <el-table-column label="加入时间" prop="createTime"></el-table-column>
      </el-table>
      <div v-else class="member-empty">暂无缩水师信息</div>
    </el-dialog>

    <!-- 实战方案购买确认弹窗 -->
    <el-dialog :title="buyDialog.title" :visible.sync="buyDialog.show" width="50%" :close-on-click-modal="false">
      <div v-if="buyDialog.row" class="buy-info">
        <div class="buy-row"><span class="buy-label">实战团队</span><span class="buy-value">{{
            buyDialog.row.teamName || '-'
          }}</span></div>
        <div class="buy-row"><span class="buy-label">期数</span><span class="buy-value">{{ buyDialog.row.preNumber
        || '-'
          }}</span></div>
        <div class="buy-row"><span class="buy-label">实战方案</span><span class="buy-value">{{ buyDialog.row.title
        || '-'
          }}</span></div>
        <div class="buy-row"><span class="buy-label">缩币价格</span><span class="buy-value">{{ buyDialog.row.coin !=
        null &&
        buyDialog.row.coin !== '' ? buyDialog.row.coin + ' 缩币' : '-' }}</span></div>
        <div class="buy-row"><span class="buy-label">认购状态</span><span class="buy-value">{{
            buyDialog.row.buyStatus ||
            '-' }}</span></div>
        <div class="buy-row"><span class="buy-label">上期实战盈亏状态</span><span class="buy-value">{{
            buyDialog.row.plStatus ||
            '-' }}</span></div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="buyDialog.show = false">取消</el-button>
                <el-button type="primary" :loading="buyLoading" @click="confirmBuy">确认购买</el-button>
            </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {

      mk1: {
        title: ['投注站申请帮扶', '实战超市大厅', '众筹招股大厅', '实战合同存档'],
        active: 0,
      },
      mk3: {
        list: []
      },
      mk5: {
        lottery: {
          arr: [
            { name: '双色球', kj: '20:00停售/21:15开奖' },
            { name: '大乐透', kj: '20:00停售/20:30开奖' },
            { name: '福彩3D', kj: '20:00停售/21:15开奖' },
            { name: '排列三', kj: '20:00停售/20:30开奖' },
          ],
          active: 0
        },
        results: [],
        history: {
          rows: [],
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      bidu: {
        show: false,
        title: '',

      },
      issueNumber: null, // 当前查询期号
      chaoshi: {
        preType: 0,
        type: 0,
        pageNum: 1,
        pageSize: 10,
        preNumber: null,
        total: 0,
      },
      chaoshi_tableData: [],
      chaoshiLoading: false,
      buyDialog: {
        show: false,
        title: '实战方案购买',
        row: null
      },
      buyLoading: false,
      memberDialog: {
        show: false,
        title: '',
        list: []
      },
    }
  },
  computed: {
    // 当前选中彩种的最新开奖结果（lottery.active 与接口 type 一一对应：0双色球 1大乐透 2福彩3D 3排列三）
    currentResult() {
      const list = this.mk5.results || []
      return list.find(r => r.type === this.mk5.lottery.active) || null
    },
    // 把开奖号码拆成 [{n, color}]，按彩种决定红/蓝球分界
    currentNumbers() {
      const r = this.currentResult
      if (!r || !r.openNbr) return []
      const parts = r.openNbr.replace(/,/g, ' ').split(/\s+/).filter(x => x && x !== 'null')
      const type = this.mk5.lottery.active
      const blueFrom = type === 0 ? 6 : type === 1 ? 5 : 99
      return parts.map((n, i) => ({ n, color: i >= blueFrom ? 'blue' : 'red' }))
    },
  },
  mounted() {
    this.getLatestResults();
    this.getHistory();
    this.getTeamRecommend();
    this.getSchemeList();
  },
  methods: {




    // 平台推荐缩水团队走马灯：返回为数组，直接赋值 mk3.list
    getTeamRecommend() {
      this.$http.get('/stage-api/assist/team/recommend/list').then(res => {
        const base = res && res.data !== undefined ? res.data : res
        this.mk3.list = Array.isArray(base) ? base : []
      }).catch(() => {
        this.mk3.list = []
      })
    },

    // 实战超市大厅列表：GET /stage-api/assist/market/scheme/list
    // 参数即 this.chaoshi 整体：preType(彩种) / type(期数:0最新/1上一/2下一) / pageNum / pageSize / preNumber(期号)
    getSchemeList() {
      this.chaoshiLoading = true
      this.$http.get('/stage-api/assist/market/scheme/list', {
        params: this.chaoshi
      }).then(res => {
        this.issueNumber = res.lastNumber
        this.chaoshi_tableData = res.marketInfos.rows || []
        this.chaoshi.total = res.marketInfos.total || 0
      }).catch(() => {
        this.chaoshi_tableData = []
        this.chaoshi.total = 0
      }).finally(() => {
        this.chaoshiLoading = false
      })
    },
    // 切换彩种（双色球/大乐透）：重置分页后重新拉取
    switchChaoshiLottery(type) {
      this.chaoshi.preType = type
      this.chaoshi.pageNum = 1
      this.getSchemeList()
    },
    // 切换期数类型（最新期/上一期/下一期）：期号由后端按 type 定位，前端传当前 issueNumber 作为参考
    switchChaoshiPeriod(type) {
      this.chaoshi.type = type
      this.chaoshi.pageNum = 1
      this.chaoshi.preNumber = this.issueNumber
      this.getSchemeList()
    },
    // 翻页
    onChaoshiPage(page) {
      this.chaoshi.pageNum = page
      this.getSchemeList()
    },
    // 点击购买：打开购买弹窗
    chaoshiItemBuy(item) {
      this.openBuyDialog(item)
    },
    // 点击下载：走统一下载
    chaoshiItemDownload(item) {
      this.download(item)
    },
    // 打开购买弹窗
    openBuyDialog(row) {
      this.buyDialog.row = row
      this.buyDialog.title = (row.teamName || '实战方案') + ' - 购买'
      this.buyDialog.show = true
    },
    // 确认购买
    confirmBuy() {
      const row = this.buyDialog.row
      if (!row) return
      this.buyLoading = true
      this.$http.get('/stage-api/assist/market/scheme/download', {
        params: { marketId: row.id },
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('购买成功')
          this.buyDialog.show = false
        } else {
          this.$message.error(res.msg || '购买失败')
        }
      }).catch(() => { }).finally(() => {
        this.buyLoading = false
        this.getSchemeList()
      })
    },
    // 下载方案：item.schemeFilePath 为文件相对路径，补上前缀后触发当前页下载（不跳页）
    download(item) {
      const path = item && item.schemeFilePath
      if (!path) {
        this.$message.warning('该方案暂无可下载文件')
        return
      }
      const url = this.$img(path)
      const fileName = String(path).split('/').pop() || '方案文件'
      this.$message.info('正在准备下载…')
      this.$http.get(url, { responseType: 'blob' })
          .then(res => {
            const blob = (res && res instanceof Blob) ? res : (res && res.data)
            if (!blob) {
              this.$message.error('下载失败：未获取到文件')
              return
            }
            const blobUrl = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = blobUrl
            a.download = fileName
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
          })
          .catch(() => {
            this.$message.error('下载失败，请检查登录状态或网络后重试')
          })
    },


    // 查看缩水师：打开弹窗展示该团队的 memberList（缩水师列表）
    goTeamDetail(item) {
      const list = Array.isArray(item.memberList) ? item.memberList : []
      this.memberDialog.title = (item.teamName || '团队') + ' - 缩水师'
      this.memberDialog.list = list
      this.memberDialog.show = true
    },
    // 查询 4 个彩种最新一期开奖结果
    getLatestResults() {
      this.$http.get('/stage-api/lottery/result/latest/all').then(res => {
        const base = res && res.data !== undefined ? res.data : res
        this.mk5.results = Array.isArray(base) ? base : []
      }).catch(() => {
        this.mk5.results = []
      })
    },
    // 分页查询当前彩种往期开奖结果
    getHistory() {
      const type = this.mk5.lottery.active
      const { pageNum, pageSize } = this.mk5.history
      this.$http.get('/stage-api/lottery/result/history', {
        params: { type, pageNum, pageSize }
      }).then(res => {
        const base = res && res.data !== undefined ? res.data : res
        this.mk5.history.rows = Array.isArray(base.rows) ? base.rows : []
        this.mk5.history.total = base.total || 0
      }).catch(() => {
        this.mk5.history.rows = []
        this.mk5.history.total = 0
      })
    },
    // 历史表格里把开奖号码拆成小球（按当前彩种决定红/蓝分界，与顶部一致）
    historyNumbers(row) {
      if (!row || !row.openNbr) return []
      const parts = row.openNbr.replace(/,/g, ' ').split(/\s+/).filter(x => x && x !== 'null')
      const type = this.mk5.lottery.active
      const blueFrom = type === 0 ? 6 : type === 1 ? 5 : 99
      return parts.map((n, i) => ({ n, color: i >= blueFrom ? 'blue' : 'red' }))
    },
    // 开奖日期只取 YYYY-MM-DD
    formatDate(t) {
      return (t && t.slice(0, 10)) || '-'
    },
    // 金额加千位符，如 337464770 -> 337,464,770；非数字原样返回
    formatMoney(v) {
      if (v === null || v === undefined || v === '') return '-'
      const num = Number(v)
      if (isNaN(num)) return v
      return num.toLocaleString('en-US')
    },
    // 切换开奖公告彩种：重置分页后按 type 重新拉取往期开奖结果
    switchLotteryType(index) {
      if (this.mk5.lottery.active === index) return
      this.mk5.lottery.active = index
      this.mk5.history.pageNum = 1
      this.getHistory()
    },
    // 历史列表翻页
    onHistoryPage(page) {
      this.mk5.history.pageNum = page
      this.getHistory()
    },
    navtit(index) {
      // 投注站申请帮扶：当前页跳转至申请表单页（外部部署实例）
      if (index == 0) {
        window.location.href = 'http://192.168.0.3:8085/#/personalCenter/tzz_bf/apply';
        return;
      }
      if (index == 1) {
        this.$router.push('/sttzzbfzx/chaoshi');
        return;
      }
      if (index == 2) {
        this.$router.push('/sttzzbfzx/zhaogu');
        return;
      }
      if (index == 3) {
        this.$router.push('/sttzzbfzx/hetong');
        return;
      }
      this.mk1.active = index
    }
  }
}
</script>

<style lang="scss" scoped>
.cs-page {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 0;
}

.tzzbd {
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  .tit {
    span {
      display: block;
      margin: auto;
      width: fit-content;
      border-bottom: 3px solid #000a7b;
      padding: 0 12px;
      font-size: 19px;
      padding-bottom: 8px;
      margin-bottom: 10px;
      color: #bd3125;
    }
  }

  p {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-top: 0;
    line-height: 25px;
    margin: 0;
    font-size: 13px;
    padding: 10px;
    color: #4e8db9;
  }
}

.mk1 {
  height: 500px;
  color: #ffffff;
  background-image: linear-gradient(#165abd, #469cd9, #85d6f1);
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;

  img {
    position: absolute;
    left: calc(50% - 12%);
    max-width: 25%;
    bottom: 10px;
  }

  .tit {
    margin-top: 24px;
    margin-left: 100px;
    display: flex;
    align-items: center;

    .bt {
      background-color: #2d78c9;
      padding: 20px;
    }

    .nav {
      span {
        cursor: pointer;

        &.active {
          position: relative;

          &::after {
            content: '';
            display: block;
            position: absolute;
            left: calc(50% - 25px);
            bottom: -7px;
            width: 50px;
            height: 3px;
            background-color: #ffffff;
          }
        }
      }
    }

    span {
      margin: 10px 30px;
    }
  }

  .content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    .cont {
      width: 610px;
      display: flex;
      flex-direction: column;
      align-items: center;

      h1 {
        font-weight: unset;
        position: relative;

        &::before,
        &::after {
          content: '';
          display: inline-block;
        }

        &::before {
          position: absolute;
          top: -26px;
          left: -35px;
          border-top: 4px solid rgba(255, 255, 255, 0.85);
          border-left: 4px solid rgba(255, 255, 255, 0.85);
          width: 83px;
          height: 33px;
        }

        &::after {
          position: absolute;
          bottom: -6px;
          right: -40px;
          border-bottom: 4px solid rgba(255, 255, 255, 0.85);
          border-right: 4px solid rgba(255, 255, 255, 0.85);
          width: 37px;
          height: 48px;
        }
      }

      p {
        width: 250px;
        display: flex;
        justify-content: space-between;
      }

      .btns {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 35px;

        span {
          background-color: rgba(255, 255, 255, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.5);
          padding: 10px 30px;
          border-radius: 24px;
          cursor: pointer;
          user-select: none;
          transition: all 0.25s;

          &:hover {
            background-color: #ffffff;
            color: #165abd;
            box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
            transform: translateY(-2px);
          }
        }
      }

      .more {
        width: 50px;
        height: 50px;
        position: absolute;
        bottom: 0px;
        animation: moreFloat 2s ease-in-out infinite;

        &::before,
        &::after {
          content: '';
          display: block;
          width: 20px;
          height: 20px;
          border-bottom: 3px solid rgba(255, 255, 255, 0.7);
          border-right: 3px solid rgba(255, 255, 255, 0.7);
          transform: rotate(45deg);
          position: absolute;
          left: 25%;
        }

        &::before {
          top: 28%;
        }
      }
    }
  }
}

@keyframes moreFloat {
  0%,
  100% {
    transform: translateY(-5px);
  }

  50% {
    transform: translateY(5px);
  }
}

.mk2 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 60px auto;

  img {
    cursor: pointer;
  }
}

.mk3 {
  margin: 40px auto;

  .mk3-tit {
    text-align: center;
    margin-bottom: 30px;

    .zh {
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 6px;
    }

    .en {
      font-size: 14px;
      color: #999999;
      letter-spacing: 2px;
    }
  }

  .team-card {
    height: 100%;
    display: flex;
    align-items: center;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);

    .imgBlock {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      .team-logo {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 60px;
        flex-shrink: 0;
        background: #e8e8e8;
      }
    }

    .team-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .team-name {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 16px;
      }

      .team-slogan {
        font-size: 14px;
        color: #666666;
        margin-bottom: 16px;
      }

      .team-desc {
        font-size: 14px;
        color: #888888;
        line-height: 1.8;
        margin-bottom: 24px;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .team-action {
        .btn {
          display: inline-block;
          background-color: #409eff;
          color: #ffffff;
          font-size: 14px;
          padding: 8px 24px;
          border-radius: 4px;
          cursor: pointer;
          user-select: none;

          &:hover {
            background-color: #66b1ff;
          }
        }
      }
    }
  }
}

.mk4 {
  color: #ffffff;

  .ul {
    display: flex;

    ul {
      list-style: none;
      padding-right: 70px;

      li {
        &:nth-child(1) {
          font-weight: bold;
          font-size: 16px;
          position: relative;

          &::after {
            content: '';
            display: block;
            width: 30px;
            height: 2px;
            background-color: #ffffff;
            margin-top: 10px;
          }

          cursor: default;
        }

        cursor: pointer;
        margin: 10px 0;
        font-size: 12px;
      }
    }
  }

  .ewm {
    margin-left: 40px;
    display: flex;
    padding-bottom: 30px;

    >div {
      text-align: center;
      margin-right: 10px;

      .img {
        width: 100px;
        height: 100px;
        line-height: 100px;
        color: #000000;
        background-color: #ffffff;
        margin-bottom: 10px;
      }
    }
  }
}

.mk5 {
  margin: 30px auto;
  padding: 20px 0;
  // height: 800px;
  position: relative;

  >.tit {
    text-align: center;
    margin-bottom: 30px;

    h3 {
      display: inline-block;
      position: relative;
      margin: 0;

      &:after {
        content: '';
        display: block;
        height: 2px;
        width: 70px;
        position: absolute;
        left: calc(50% - 35px);
        background-color: #000000;
      }
    }
  }

  .content {
    background-color: #ffffff;
    padding: 30px;

    .lottery {
      color: #e6000e;
      display: flex;
      justify-content: space-between;

      >div {
        cursor: pointer;

        span {
          color: #000000;
          font-weight: bold;
          font-size: 18px;

          &.active {
            padding-bottom: 3px;
            border-bottom: 5px solid #63a8f4;
          }
        }
      }
    }

    .info {
      margin: 40px 0 20px;
      display: flex;

      img {
        margin-right: 20px;
        width: 100px;
        height: 100px;
      }

      >div {
        flex: 1;

        .one {
          display: flex;
          justify-content: space-between;

          >div {
            span {
              margin-right: 20px;

              b {
                color: red;
              }

              &.lt-name {
                color: #e6000e;
                font-weight: bold;
                font-size: 20px;
              }
            }
          }
        }

        .num {
          margin-top: 10px;

          span {
            display: inline-block;
            width: 50px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            font-size: 25px;
            margin-right: 10px;
            border-radius: 50%;
            color: #ffffff;
            font-weight: bold;

            &.red {
              background-image: linear-gradient(135deg, #ff7a7a 0%, #e6000e 100%);
            }

            &.blue {
              background-image: linear-gradient(135deg, #5aa9ff 0%, #1565d8 100%);

              box-shadow: 0 0 0 2px #bcd8ff;
            }
          }
        }
      }
    }

    .kjjg {
      .tit {
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        padding: 10px 0;
      }

      .hnum {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        color: #ffffff;
        font-size: 13px;
        font-weight: bold;
        margin: 2px 3px;

        &.red {
          background-image: linear-gradient(135deg, #ff7a7a 0%, #e6000e 100%);
        }

        &.blue {
          background-image: linear-gradient(135deg, #5aa9ff 0%, #1565d8 100%);
        }
      }

      .his-page {
        text-align: center;
        margin-top: 14px;
      }

      // 期号整列加粗（el-table 内部 td 不受 scoped 限制，需穿透）
      ::v-deep .cycle-col .cell {
        font-weight: bold;
      }

      // 总销售额 / 奖池用不同颜色区分
      .sale-val {
        color: #e6a23c;
        font-weight: bold;
      }

      .pool-val {
        color: #1565d8;
        font-weight: bold;
      }
    }

    .szcs {
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      box-shadow: 0 4px 16px rgba(21, 101, 216, 0.08);
      margin-top: 10px;

      .left {
        background: linear-gradient(180deg, #eef4ff 0%, #f7faff 100%);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        display: flex;
        flex-direction: column;
        padding: 16px;
        gap: 14px;

        .panel {
          background: #ffffff;
          border: 1px solid rgba(21, 101, 216, 0.12);
          border-radius: 10px;
          padding: 16px 18px;
          display: flex;
          align-items: center;
          box-shadow: 0 2px 8px rgba(21, 101, 216, 0.06);

          .ico {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background-image: linear-gradient(135deg, #5aa9ff 0%, #1565d8 100%);
            color: #fff;
            font-size: 20px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin-right: 12px;
          }

          .txt {
            .t {
              font-size: 16px;
              font-weight: bold;
              color: #1565d8;
              margin-bottom: 4px;
            }

            .d {
              font-size: 12px;
              color: #6b7c93;
              line-height: 1.5;
            }
          }
        }
      }

      .right {
        flex: 1;
        background: #ffffff;

        .tit {
          text-align: center;
          border-bottom: 2px solid #1565d8;
          padding: 16px 0;
          font-size: 18px;
          font-weight: bold;
          color: #1565d8;
          letter-spacing: 2px;

          &::after {
            content: '';
            display: block;
            width: 40px;
            height: 3px;
            background: #1565d8;
            border-radius: 2px;
            margin: 8px auto 0;
          }
        }

        .cs-toolbar {
          display: flex;
          justify-content: flex-end;
          gap: 8px;
          padding: 10px 16px 0;

          .cs-tag {
            font-size: 13px;
            color: #6b7c93;
            padding: 4px 12px;
            border-radius: 14px;
            border: 1px solid rgba(21, 101, 216, 0.25);
            cursor: pointer;
            user-select: none;

            &.active {
              background: #1565d8;
              color: #ffffff;
              border-color: #1565d8;
            }
          }


        }

        // 实战超市导航条：彩种（左）/ 期数（右）同一行，下方留间距
        .cs-toolbar.cs-nav {
          justify-content: space-between;
          align-items: center;
          padding: 12px 16px 0;
          margin-bottom: 12px;

          .cs-group {
            display: flex;
            gap: 8px;
          }
        }
      }
    }
  }
}

::v-deep.el-dialog__body {
  padding-top: 0;
}

.member-empty {
  text-align: center;
  color: #999999;
  padding: 30px 0;
}

// 实战方案购买信息块
.buy-info {
  padding: 8px 4px;

  .buy-row {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-bottom: 1px solid #f0f2f5;

    &:last-child {
      border-bottom: none;
    }
  }

  .buy-label {
    width: 130px;
    flex-shrink: 0;
    color: #6b7c93;
    font-size: 14px;
  }

  .buy-value {
    flex: 1;
    color: #303133;
    font-size: 14px;
    word-break: break-all;
  }
}

::v-deep .szcs .el-table th {
  background-color: #eef4ff;
  color: #1565d8;
  font-weight: bold;

  .cell {
    text-align: center;
  }
}

::v-deep .szcs .el-table td,
::v-deep .szcs .el-table th.is-leaf {
  border-bottom: 1px solid rgba(21, 101, 216, 0.12);
}

::v-deep .szcs .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #f5f9ff;
}
</style>